import React, { useState } from "react";
import { ChevronRight, ChevronDown } from "react-ikonate";
import styles from "./ProjectsPageCollapsible.module.css";

export function ProjectsPageCollapsible({ title, children, isOpen, onClick }) {
  // const [open, setOpen] = useState(false);

  return (
    <div className={styles.archiveContainer} onClick={onClick}>
      <div  className={styles.toggler}>
        {title} {isOpen ? <ChevronDown /> : <ChevronRight />}
      </div>
      <div
        className={isOpen ? styles.contentParentOpen : styles.contentParentClosed}
      >
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
